import lodash from 'lodash'
import moment from 'moment'
import React, { ReactElement, useMemo } from 'react'
import styled from 'styled-components'

import Badge from '../../../../../../../1stlog-ui/src/components/Badge'
import {
  FieldPrefix,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import HtmlRadio from '../../../../../../../1stlog-ui/src/components/HtmlRadio'
import { ListGroupItem } from '../../../../../../../1stlog-ui/src/components/ListGroup'
import Overlay from '../../../../../../../1stlog-ui/src/components/Overlay'
import { useProductsContext } from '../../../../Products/ProductsContext'
import { TOrderEntryProduct } from '../../../../types'
import useOrderEntry from '../../../../useOrderEntry'
import RequireConfirmation from '../../RequireConfirmation'
import Acceptance from './Acceptance'
import DispositionSettings from './DispositionSettings'
import TimeBlock from './TimeBlock'
import Timings from './Timings'

const Wrapper = styled(ListGroupItem)`
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 5px 5px;
`

const Title = styled.h4`
  cursor: pointer;
`

type TProductProps = {
  product: TOrderEntryProduct
  isPickup: boolean
}

const Product = (props: TProductProps): ReactElement => {
  const { product, isPickup } = props

  const {
    id,
    slaType,
    slaTypeId,
    disabled,
    isExternal,
    provider,
    pickupType,
    deliveryType,
    avisTime,
    pickupFromTime,
    pickupUntilTime,
    deliveryFromTime,
    deliveryUntilTime,
    isDispositionProduct,
    timings,
  } = product

  const productsContext = useProductsContext()

  const { id: orderEntryId, preset } = useOrderEntry()

  const fieldId = `${orderEntryId}_${lodash.get(productsContext, 'id')}`

  const [selectedProductId, setSelectedProductId] = useField(
    'selectedProductId',
    {
      asState: true,
    },
  )

  const selectProduct = (): void => setSelectedProductId(id)

  const isSelected = useMemo(
    () => String(selectedProductId) === String(id),
    [selectedProductId, id],
  )

  // const { isPickupAndDelivery } = preset
  const isPickupAndDelivery = false

  const isSelfPickup = pickupType === 'slf'
  const isSelfDelivery = deliveryType === 'slf'

  const deliveryTimeString = deliveryFromTime
    ? moment(deliveryFromTime).format('DD.MM.YYYY')
    : i18n.t('unknown', 'Unbekannt')
  const pickupTimeString = pickupUntilTime
    ? moment(pickupUntilTime).format('DD.MM.YYYY')
    : i18n.t('unknown', 'Unbekannt')

  return (
    <Wrapper>
      {disabled && <Overlay opacity={0.4} />}

      <div className="pl-3">
        <HtmlRadio
          value={isSelected}
          onChange={selectProduct}
          name={fieldId}
          disabled={disabled}
        />
      </div>

      <div className="ml-2" style={{ flex: '1 0 0' }}>
        <Title onClick={selectProduct}>
          {/* {/localhost/.test(window.location) && (
            <code>
              [{id}|{slaType}]
            </code>
          )}{" "} */}
          {lodash.get(product, 'name', i18n.t('unknown', 'Unbekannt'))}{' '}
          {!isDispositionProduct && (
            <span>
              (
              {lodash.get(product, 'shortcode', '') !== ''
                ? lodash.get(product, 'shortcode', '?')
                : lodash.get(product, 'slaType', '?')}
              )
            </span>
          )}
          {isExternal ? (
            <span style={{ fontSize: '0.85em' }}>
              {' '}
              <Badge>Durchgeführt von {provider}</Badge>
            </span>
          ) : null}
        </Title>
        {product.description && product.description !== '' && (
          <h5 className="mt-1">{product.description}</h5>
        )}

        {!isDispositionProduct && !product.isRuntimeDisplayDisabled && (
          <div className="mt-1 mb-1">
            {isPickup
              ? i18n.t('pickup_until', 'Abholung bis')
              : i18n.t('delivery_from', 'Zustellung ab')}{' '}
            <strong>{isPickup ? pickupTimeString : deliveryTimeString}</strong>
          </div>
        )}

        {!isDispositionProduct && <Acceptance avisTime={avisTime} />}
        {isSelected && (
          <>
            {!isDispositionProduct && (
              <div className="mr-4">
                <hr />
              </div>
            )}

            {/* <Field name="test" label="testfield for productSettings">
                <Input />
              </Field> */}

            {isDispositionProduct ? (
              <FieldPrefix prefix="productSettings">
                <DispositionSettings id={id} />
              </FieldPrefix>
            ) : (
              <div className="d-flex">
                {isPickupAndDelivery ? (
                  <FieldPrefix
                    prefix={isPickup ? 'pickupTime' : 'deliveryTime'}
                  >
                    {/* <TimeBlock product={product} isPickup={isPickup} /> */}
                    <Timings product={product} isPickup={isPickup} />
                  </FieldPrefix>
                ) : (
                  <>
                    <div>
                      <div className="d-flex">
                        <div style={{ flex: '1 1 0' }}>
                          <FieldPrefix prefix="pickupTime">
                            <TimeBlock
                              product={product}
                              isPickup
                              isPickupProduct={isPickup}
                            />

                            {/* <Timings
                            product={product}
                            isPickup
                            isPickupProduct={isPickup}
                          /> */}
                          </FieldPrefix>
                        </div>
                        <div style={{ flex: '1 1 0' }}>
                          <FieldPrefix prefix="deliveryTime">
                            <TimeBlock
                              product={product}
                              isPickupProduct={isPickup}
                              isPickup={false}
                            />
                            {/* <Timings
                            product={product}
                            isPickupProduct={isPickup}
                          /> */}
                          </FieldPrefix>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
            <FieldPrefix prefix="confirmation">
              <RequireConfirmation />
            </FieldPrefix>
          </>
        )}
      </div>
    </Wrapper>
  )
}

export default Product
